import React, { Component } from 'react';
import { Input, Modal, Button, Tabs, Row, Col, Dropdown, Icon, Menu, Collapse, Form, Select, Radio, DatePicker } from 'antd';

import './profile.css';
import Skeleton from 'react-loading-skeleton';
const Panel = Collapse.Panel;
const { TextArea } = Input;


class SocialMedia extends Component {

    state = {
        // value: "type here!",
        isInEditMode: false
    }

    changeEditMode = () => {
        this.setState({
            isInEditMode: !this.state.isInEditMode
        })
    }

    updateComponentValue = () => {
        this.setState({
            isInEditMode: false,
            // value: this.refs.theTextInput.value
        })
    }

    renderEditView = () => {
        const Option = Select.Option;
        const FormItem = Form.Item;

        return (<div className='container'>
            <Collapse defaultActiveKey={['1']} accordion bordered={false} >
                <Panel key="1" header={<div> <span className="myProfile-collapse-header"> Social Media Groups and Links </span> <span style={{ fontSize: '12px', color: 'grey', fontWeight: 300, marginLeft: '14px' }}>Edting...</span> </div>}>
                    <Form className='myprofile-form' style={{display:'block'}}>
                        <p className='widget-content-section'>
                            <Row type='flex' justify='space-between'>
                            <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="  Facebook Link "
                                    >
                                        <Input placeholder="  Facebook Link " 
                                        prefix={<i class="fa fa-facebook" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}/>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Twitter Handle"
                                    >
                                        <Input placeholder=" Twitter Handle" 
                                        prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}/>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-between'>
                            <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" LinkedIn Profile Link"
                                    >
                                        <Input placeholder=" LinkedIn Profile Link" 
                                        prefix={<i class="fa fa-linkedin" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}/>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Social Media Group Links"
                                    // {...formItemLayout}
                                    >
                                        <TextArea placeholder="Social Media Group Links" autosize={{ minRows: 2, maxRows: 10 }} />
                                    </FormItem>
                                </Col>
                            </Row>
                            <hr className="line-divider-full" />
                                <Row type='flex' justify='space-around'>
                                    <Col xs={23} sm={23} md={18} lg={18} xl={18}>
                                    <Row type='flex' justify='space-around'>
                                    <Col xs={22} sm={22} md={9} lg={9} xl={9}>
                                        <Button className="myprofile-cancel-btn" onClick={this.changeEditMode}>Cancel</Button>
                                    </Col>
                                   <Col xs={22} sm={22} md={9} lg={9} xl={9}>
                                        <Button className="save-change-btn" onClick={this.updateComponentValue} type="primary">SAVE CHANGE</Button>
                                    </Col>
                                    </Row>
                                </Col>
                                </Row>
                        </p>
                    </Form>
                </Panel>
            </Collapse>
        </div>

        )
    }

    renderDefaultView = () => {
        return (
            <div className='container'>
                <Collapse bordered={false} >
                    <Panel header={<div className="alumni-header"> <span className="myProfile-collapse-header"> Social Media Groups and Links </span>
                        <span className="editing-btn"><i class="fa fa-pencil" onClick={this.changeEditMode}></i></span>
                    </div>}>
                        <p className='widget-content-section'>
                            <Row type='flex' justify='space-between'>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Facebook Link </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Twitter Handle</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> LinkedIn Profile Link</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                            {/* </Row>
                            <Row> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Social Media Group Links </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                {/* <Col  xs={22} sm={22} md={8} lg={8} xl={8}>
                                    <label className='field-label'> DATE OF BIRTH </label>
                                </Col>
                                <Col  xs={22} sm={22} md={8} lg={8} xl={8}>
                                    <label className='field-label'> GENDER </label>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <label className='field-label'> SCOUTING ID </label>
                                    <label className='field-value'> 123565321234567654 </label>
                                </Col>
                                <Col span={24}>
                                    <label className='field-label'> EAGLE ID </label>
                                    <label className='field-value'> 1235653212345 </label>
                                </Col> */}
                            </Row>
                        </p>
                    </Panel>
                </Collapse>
            </div>
        )
    }


    render() {

        return this.state.isInEditMode ?
            this.renderEditView() :
            this.renderDefaultView()
    }
}

export default SocialMedia;


// WEBPACK FOOTER //
// ./src/components/AlumniProfile/SocialMedia.js